// Mutation hook - dodanie aktywnosci do transakcji
// POST /api/ui/sales-crm/deals/{id}/activities

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPostDealActivityRequest } from 'api/types/deals';

interface IPostDealActivityResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IPostDealActivityVariables {
  dealId: number;
  body: IPostDealActivityRequest;
}

const postDealActivity = ({
  dealId,
  body,
}: IPostDealActivityVariables): Promise<IPostDealActivityResponse> =>
  axios.post(`/sales-crm/deals/${dealId}/activities`, body);

export const usePostDealActivity = (
  options?: UseMutationOptions<IPostDealActivityResponse, IError, IPostDealActivityVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostDealActivityResponse, IError, IPostDealActivityVariables>(
    postDealActivity,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['sales-crm-deal-activities', variables.dealId]);
        await queryClient.refetchQueries(['sales-crm-deal-activities', variables.dealId]);
        options?.onSuccess?.(data, variables, context);
      },
    },
  );
};
